export const SERRANO = "#D0460B";

// FD-266346 - Replace with Slate Color post XP
export const VOLUME_PRICING_SHADE = "#5A1E09";
